module.exports = __webpack_public_path__ + "static/img/1-5.49b274c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/1-5.png
// module id = 1310
// module chunks = 0